import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import BaocaophuongtienGT from "components/Baocao/Phuongtiengiaothong/BaocaophuongtienGT.js";
export default function BCphuongtienGT() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo phương tiện giao thông đường bộ",
            tabContent: <BaocaophuongtienGT />,
          },
        ]}
      />
    </div>
  );
}
